// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".loader[data-v-8a153512] {\n  z-index: 100000000000000020000;\n}", ""]);
// Exports
module.exports = exports;
